import { render, staticRenderFns } from "./Mark.vue?vue&type=template&id=6ecc194f"
import script from "./Mark.vue?vue&type=script&lang=ts"
export * from "./Mark.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports